<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <router-link to="/pedido"> Suprimentos/Pedido de Compra </router-link>
      <label class="labelBar"> / </label>
      <label> Aprovar</label>
    </div>
    <v-container fluid>
      <v-form>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="8">
            <h2 class="display-1 font-weight-bold mb-4">Pedido de Compra</h2>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="pedido.id"
              hide-details
              label="Pedido nº"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="idorigem"
              hide-details
              :label="origem"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-list-subheader>Dados de Faturamento</v-list-subheader>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="faturamento"
              hide-details
              solo
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="cnpj"
              label="CNPJ"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="inscricao"
              hide-details
              label="Inscrição Estadual"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-list-subheader></v-list-subheader>
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-model="endereco"
              label="Endereço"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="telefone"
              label="Telefone"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="2">
            <v-list-subheader>Endereço de Entrega</v-list-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field
              v-model="pedido.enderecoLocal"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row>
          <v-col cols="2">
            <v-list-subheader>Dados do Fornecedor</v-list-subheader>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="pedido.fornecedor"
              hide-details
              solo
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="pedido.cnpjFornecedor"
              hide-details
              label="CNPJ"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="pedido.ieFornecedor"
              hide-details
              label="Inscrição Estadual"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-list-subheader></v-list-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field
              v-model="pedido.enderecoFornecedor"
              hide-details
              label="Endereço"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="2">
            <v-list-subheader></v-list-subheader>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="pedido.contatoFornecedor"
              hide-details
              label="Contato"
              single-line
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="pedido.telefoneFornecedor"
              hide-details
              label="telefone"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="pedido.emailFornecedor"
              hide-details
              label="Email"
              single-line
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-form>

      <v-card>
        <v-data-table :headers="headers" hide-default-footer :items-per-page="-1" :items="pedido.produtos">
        </v-data-table>
      </v-card>
      <v-divider></v-divider>

      <v-row>
        <v-col cols="3">
          <v-list-subheader>Pedido Gerado Pelo Comprador: </v-list-subheader>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="formatocomprador"
            hide-details
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/pedido" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn
            @click="aprovar"
            color="success"
            class="mr-4"
            :disabled="pedido.status != 'AA' || !isApproving(idModulo)"
          >
            Aprovar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>


<script>
import { aprovarPedidoAsync  } from "../../../services/pedidoService";
import { mapState, mapActions } from "vuex";
import {
  canApproveModule,
  getUserRoles,
  logApprovalDiagnostics,
  explainApprovalButtonState,
} from "@/services/loginService";

export default {
  name: "aprovarPedido",
  data: () => ({
    overlay: false,
    valid: true,
    readOnly: false,
    idModulo: 11,
    faturamento: "SALUM CONSTRUÇÕES LTDA",
    cnpj: "19.739.564/0001-79",
    inscricao: "062.566.556.0021",
    endereco:
      "RUA DOS TIMBIRAS, 559 - Bairro Funcionários - Belo Horizonte / MG - CEP:30.140-060",
    telefone: "(31) 3271 2151",
    formatocomprador: null,
    headers: [
      { text: "SC", value: "idSolicitacao", sortable: false },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Local", value: "localEntrega", sortable: false },
      { text: "Qnt", value: "idProduto", sortable: false },
      { text: "Item", value: "quantidade", sortable: false },
      { text: "Codigo", value: "codigo", sortable: false },
      { text: "Un", value: "unidadeMedida", sortable: false },
      { text: "Vr.Unit.", value: "valorUnitario", sortable: false },
      { text: "Desc.", value: "descontoProduto", sortable: false },
      { text: "Total c/ Desc.", value: "total", sortable: false },
      { text: "Prazo", value: "prazoEntrega", sortable: false },
    ],
  }),
  computed: {
    ...mapState("pedido", ["pedido"]),
  },
  methods: {
    ...mapActions("pedido", ["updatePedido"]),
    isApproving(id) {
      const pode = canApproveModule(id);
      logApprovalDiagnostics("Pedido/Aprovar:Aprovar", explainApprovalButtonState({
        modulo: id,
        registro: this.pedido,
        action: "aprovar",
        statusPermitidos: ["AA"],
      }));
      return pode;
    },
    async aprovar() {
      this.overlay = true;
      const resposta = await aprovarPedidoAsync(
        this.pedido.id,
      );
        if (resposta?.status && resposta.status != 200)  {
        this.overlay = false;
        this.$alert(resposta.message, "Descupe, falha na operação!", "error");
      } else {
        this.overlay = false;
        this.pedido.status = 'EP';
        this.updatePedido(this.pedido);
        this.$router.push("/pedido");
      }
    },
  },
  created: function () {
    this.readOnly = true;
    const data = new Date(this.pedido.dataCriacao);
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();

    const horas = String(data.getHours()).padStart(2, "0");
    const minutos = String(data.getMinutes()).padStart(2, "0");
    const segundos = String(data.getSeconds()).padStart(2, "0");
    this.formatocomprador = this.pedido.comprador + " as " + horas +':'+ minutos + ':' + segundos +
      " do dia " + dia +'/' + mes +'/' + ano;
    this.origem =
      this.pedido.idMapaCotacao != null && this.pedido.idMapaCotacao > 0
        ? "Mapa"
        : "Requisicao";
    this.idorigem =
      this.pedido.idMapaCotacao != null && this.pedido.idMapaCotacao > 0
        ? this.pedido.idMapaCotacao
        : this.pedido.idRequisicao;
        
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
};
</script>
